
const SoftBranding = {
    "companyName": "",
	"productName": "",
	"logoMainScreen": "",
	"logoLoginScreen": "",
	"logoClinic": "",
	"logoSplashScreen": "",
	"logoReport": "",
	"backgroundImage": "",
	"backgroundVideo": "",
	"applicationColor1": "",
	"applicationColor2": "",
	"splashScreenColor": "",
	"website": "",
	"manualLink": "",
	"correctivesLink": "",
	"supportWebsite": "",
	"supportEmail": "",
	"customTerms": {},
	"regions": []
}
export default SoftBranding;